import { filter, take, tap } from 'rxjs';
import { TUI_IS_MOBILE_RES, TuiScrollbarModule } from '@taiga-ui/core';
import { TuiActiveZoneModule } from '@taiga-ui/cdk';
import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
  ViewChild,
} from '@angular/core';
import { FocusMonitor } from '@angular/cdk/a11y';

import { TabIndexDirective } from '../../../utils';
import { IconComponent } from '../../../icon';

@Component({
  selector: 'iss-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: [ './side-nav.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    IconComponent,
    TuiActiveZoneModule,
    TuiScrollbarModule,
    TabIndexDirective,
  ],
})
export class SideNavComponent implements OnChanges, AfterViewChecked {
  private static readonly EXPANDED_CLASS = 'expanded';
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly focusMonitor = inject(FocusMonitor);
  private readonly isMobileRes$ = inject(TUI_IS_MOBILE_RES);

  @Input({ required: true }) public expanded?: boolean | null;
  @Output() public readonly expandedChange = new EventEmitter<boolean>();

  @ViewChild('ref') public ref!: ElementRef<HTMLElement>;

  public ngOnChanges(): void {
    this.toggle(SideNavComponent.EXPANDED_CLASS, Boolean(this.expanded));
  }

  public toggleExpanded(): void {
    this.expanded = !this.expanded;
    this.toggle(SideNavComponent.EXPANDED_CLASS, this.expanded);
    this.expandedChange.emit(this.expanded);
  }

  private toggle(token: string, force?: boolean): void {
    this.elementRef.nativeElement.classList.toggle(token, force);
  }

  public onActiveZone($event: boolean): void {
    if (!$event) {
      this.isMobileRes$.pipe(
        filter(Boolean),
        tap(() => this.toggleExpanded()),
        take(1),
      ).subscribe();
    }
  }

  public ngAfterViewChecked(): void {
    if (this.expanded) {
      this.isMobileRes$.pipe(
        filter(Boolean),
        tap(() => this.focusMonitor.focusVia(this.ref, 'program')),
        take(1),
      ).subscribe();
    }
  }
}
